import { inject } from '@angular/core';
import { crmLoginHandleSuccessDefaultImpl, CrmLoginHandleSuccessFunction } from '@touch4it/ng-swp/auth';

import { ProfilesApiService } from '~/api/profiles/profiles-api.service';

export const loginHandleSuccess: CrmLoginHandleSuccessFunction = () => {
  const original = crmLoginHandleSuccessDefaultImpl();
  const profiles = inject(ProfilesApiService);

  return (_) => {
    profiles.invalidate();
    return original(_);
  };
};
